import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import { EToy } from './etoy.js';
import { vec3 } from 'gl-matrix';
import { EventsClient } from '../events-client.js';
import { IntifaceController, SupportedAction } from '../IntifaceController.js';
import Logger from '../utils/logger.js';

const MODULE = 'OscillatingRot';

/**
 * oscillating-rot
 */
export class OscillatingRot extends EToy {
    static TypeName = 'oscillating-rot';

    /* Properties that are configurable in the editor */

    @property.float(4.0)
    effectDistance: number = 4.0;
    @property.float(1.0)
    maxEffectIntensity: number = 1.0;
    @property.int(10)
    secondsPerCycle: number = 10.0;
    @property.float(500)
    sustainMs: number = 500.0;
    @property.int(10)
    updatesPerSecond: number = 10.0;

    private _accumulator = 0;
    private _phaseTime = 0;
    private _tmpSelf = vec3.create();
    private _tmpPlayer = vec3.create();

    update(dt: number) {
        this._accumulator += dt;
        this._phaseTime += dt;
        const interval = 1 / Math.max(1, this.updatesPerSecond);
        if (this._accumulator < interval) return;
        this._accumulator = 0;

        const player = EventsClient.instance?.activePlayerObject;
        if (!player) {
            Logger.warn('[OscillatingRot] No playerObject; skipping', MODULE);
            return;
        }
        
        this.object.getPositionWorld(this._tmpSelf);
        player.getPositionWorld(this._tmpPlayer);
        const dx = this._tmpSelf[0] - this._tmpPlayer[0];
        const dy = this._tmpSelf[1] - this._tmpPlayer[1];
        const dz = this._tmpSelf[2] - this._tmpPlayer[2];
        const dist = Math.hypot(dx, dy, dz);
        
        let magnitude = 0;
        if (dist > this.effectDistance) {
            magnitude = 0;
        } else  {
            magnitude = Math.sin((this._phaseTime / this.secondsPerCycle) * Math.PI * 2) * this.maxEffectIntensity;
        }

        // Wrap phase to avoid unbounded growth
        if (this._phaseTime >= this.secondsPerCycle) {
            this._phaseTime -= this.secondsPerCycle;
        }
        
        IntifaceController.instance.hapticEnvironment.registerInfluence(this.object, SupportedAction.Rotate, [magnitude], this.sustainMs);
    }
}
